import Collapse from '@material-ui/core/Collapse'
import Add from '@material-ui/icons/Add'
import React, { useEffect, useState } from 'react'
import LockerTypeForm from '../../components/LockerType/LockerTypeForm/LockerTypeForm'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Search from '../../components/UI/Search/Search'
import Spinner from '../../components/UI/Spinner/Spinner'
import Table from '../../components/UI/Table/Table'
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'

const LockerTypes = (props) => {

    const [loading, setLoading] = useState(false)
    const [rerender, setRerender] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [pageCount, setPageCount] = useState(0)
    const [tableData, setTableData] = useState([])
    const [permission, setPermission] = useState(window.localStorage.getItem("permission"))
    const [lockerTypes, setLockerTypes] = useState([])
    const [newLockerTypePage, setNewLockerTypePage] = useState(false)
    const [edit, setEdit] = useState(false)
    const [lockerType, setLockerType] = useState('')
    const [searchParams, setSearchParams] = useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])
    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "lockerType": {
                "description": searchParams.description.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/lockertypes/getLockerTypes'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.lockerTypes)
                    pushData(newList)
                    setLockerTypes(newList)
                    setPageCount(result.count)
                    setLoading(false);
                }
            })
            .catch(error => console.log(error))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'description',
                header: 'نام',
                align: 'center',
            },
            {
                accessorKey: 'length',
                header: 'طول(سانتیمتر)',
                align: 'center',
            },
            {
                accessorKey: 'width',
                header: 'عرض(سانتیمتر)',
                align: 'center',
            },
            {
                accessorKey: 'height',
                header: 'ارتفاع(سانتیمتر)',
                align: 'center',
            },
            {
                accessorKey: 'weight',
                header: 'وزن(گرم)',
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                description: d.description,
                length: d.length,
                width: d.width,
                height: d.height,
                weight: d.weight,
            });
        })
        buttons.push({ id: 1, text: 'ویرایش', clicked: editLockerType });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        setLoading(true)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const toggleNewLockerForm = (value) => {
        if (value == false) {
            search();
        }
        setNewLockerTypePage(value)
    }

    const addNewLockerType = (event, id) => {
        setLockerType('')
        setEdit(false)
        toggleNewLockerForm(true)
    }

    const editLockerType = (id, data) => {
        const lck = data.filter(l => l.id === id);
        if (!!lck && lck.length > 0) {
            setLockerType(lck[0])
            setEdit(true)
            toggleNewLockerForm(true)
        }
    }


    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>

    return (
        <>
            {loading ? <Spinner /> : ''}
            <Collapse in={!newLockerTypePage}>
                <Search class="orders-search" form={form} />
                {permission.includes != null && permission.includes('LOCKER_TYPE_WRITE') ?
                    <div className="row justify-content-center mt-3 ml-3">
                        <div className="UserGeneralBtn mb-2">
                            <div onClick={(event) => addNewLockerType(event)} className="Add">
                                <Add className="UserIcon" />
                            </div>
                        </div>
                    </div>
                    : ''
                }
                {rerender ?
                    // <Spinner />
                    <Table hasDetails={false} data={lockerTypes} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={190} loading={loading} />
                    :
                    <Table hasDetails={false} data={lockerTypes} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={190} loading={loading} />
                }
            </Collapse>
            <Collapse in={newLockerTypePage}>
                {newLockerTypePage ?
                    <LockerTypeForm edit={edit} lockerType={edit ? lockerType : ''} toggleNewLockerForm={toggleNewLockerForm} />
                    : ''}
            </Collapse>
        </>
    )
}

export default LockerTypes